export const createPriceMapByProcessingCode = (processingCode, prices) => {
  return prices
    .filter(({ option }) => option === processingCode)
    .reduce((res, { code: { code }, price }) => {
      res[code] = price;
      return res;
    }, {});
};
